import { createFileRoute } from '@tanstack/react-router'

import { shiftDate, today } from '../../lib/format'
import { historyQuery } from '../../lib/queries'
import { History } from '../../screens/History'

export const Route = createFileRoute('/history/')({
  validateSearch: (search: Record<string, unknown>): { from?: string; to?: string } => ({
    from: typeof search.from === 'string' ? search.from : undefined,
    to: typeof search.to === 'string' ? search.to : undefined,
  }),
  loaderDeps: ({ search }) => ({ from: search.from, to: search.to }),
  loader: ({ context, deps }) => {
    const to = deps.to ?? today()
    return context.queryClient.ensureQueryData(historyQuery(deps.from ?? shiftDate(to, -60), to))
  },
  component: History,
})
